export const menus = [
  {
    text: "全部",
    type: 0,
  },
  {
    text: "华语",
    type: 7,
  },
  {
    text: "欧美",
    type: 96,
  },
  {
    text: "韩国",
    type: 8,
  },
  {
    text: "日本",
    type: 16,
  },
];
